import React from 'react';
import { Link } from 'react-router-dom';
import './css/Contact.css';
import buildingImage from '../img/bairshil/0-02-06-13e8e799d1b5875604fb1088256a6ea5157f12ff51ed8a93167f86d65b7e316c_6e29b35272b074c8.jpg'
import buildingImage2 from '../img/bairshil/0-02-06-463fb8fa8bb110239701c713baeb78d2cda86500dc4171af9059abfce6296d63_33c6f799fdb4498e.jpg'

const Contact: React.FC = () => {
    return (
        <div className="contact-page">
            <div className="contact-container">
                <div className="contact-header">
                    <h1 className="contact-title">ХОЛБОО БАРИХ</h1>
                    <p className="contact-subtitle">
                        Бидэнтэй холбогдож, Crown Residence-ийн талаар дэлгэрэнгүй мэдээлэл авах
                    </p>
                </div>
                <div className="contact-content">
                    <div className="contact-info">
                        <h2 className="section-title"> Холбоо мэдээлэл</h2>

                        <div className="contact-details">
                            <div className="contact-item">
                                <span className="contact-icon">📍</span>
                                <div className="contact-text">
                                    <strong>Хаяг</strong>
                                    Орхон аймаг, Баян-Өндөр сум, Оюут баг, 2А хороолол
                                </div>
                            </div>

                            <div className="contact-item">
                                <span className="contact-icon">📞</span>
                                <div className="contact-text">
                                    <strong>Утас</strong>
                                    +976 9957-1535<br />
                                    +976 9935-9230<br />
                                    +976 8810-5452
                                </div>
                            </div>

                            <div className="contact-item">
                                <span className="contact-icon">✉️</span>
                                <div className="contact-text">
                                    <strong>Имэйл</strong>
                                    info@crownresidence.mn<br />
                                    sales@crownresidence.mn
                                </div>
                            </div>
                            <div className="contact-item">
                                <span className="contact-icon">🌐</span>
                                <div className="contact-text">
                                    <strong>Сошиал медиа</strong>
                                    <Link to="https://www.facebook.com/share/17VkY462vJ/" className="Partners-link">
                                        facebook.com/share/17VkY462vJ/
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="map-container">
                        <h2 className="section-title">Байршил</h2>
                        <div className="map-wrapper">
                            <iframe
                                src="https://maps.google.com/maps?q=49.03239,104.0658&z=15&output=embed"
                                className="map-iframe"
                                title="Crown Residence Location"
                                loading="lazy"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                    <div className='Location-off-building'>
                        <h2 className="section-title">Баригдаж буй барилга</h2>
                        <div className='Location-off-building-container'>
                            <img src={buildingImage} alt="Crown Residence Building 1" className="building-image" />
                            <img src={buildingImage2} alt="Crown Residence Building 2" className="building-image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;